import { render, staticRenderFns } from "./RootModal.vue?vue&type=template&id=5d127c3b&scoped=true&"
import script from "./RootModal.vue?vue&type=script&lang=js&"
export * from "./RootModal.vue?vue&type=script&lang=js&"
import style0 from "./RootModal.vue?vue&type=style&index=0&id=5d127c3b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d127c3b",
  null
  
)

export default component.exports